<template>
	<div :class="isCollapse?'aside aside-collapse':'aside'">
		<div class="side-title">
			<img src="@/assets/logo.png" alt="">
			<span>百递指数</span>
		</div>
		<div class="side-nav">
			<el-menu :collapse="isCollapse" background-color="#222D32" active-text-color="#409EFF" router ref="navbar"
				:default-active="defActive" menu-trigger="click" unique-opened :collapse-transition="false"
				mode="vertical">
				<nav-item v-for="(item, n) in navList" :item="item" :navIndex="String(n)" :key="n">
				</nav-item>
			</el-menu>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'

	import NavItem from '@/components/NavItem'
	export default {
		components: {
			NavItem
		},
		data() {
			return {
				navList: [{
						icon: 'el-icon-s-home',
						path: '/home',
						name: '首页'
					},
					{
						icon: 'el-icon-s-data',
						path: '/area',
						name: '地区数据',
					},
					{
						icon: 'el-icon-s-flag',
						path: '/circuit',
						name: '路线数据',
					},
					{
						icon: 'el-icon-star-on',
						path: '/concern',
						name: '我的关注',
					},
				]
			}
		},
		methods: {
			selectMenu(index, indexPath) {
				/**
				 * 在选择父级菜单时自动关闭其下所有子菜单
				 * 选择时获取点击菜单的父级index，并计算得到该index在已打开菜单中的索引值，
				 * 关闭位于当前打开菜单中该索引值之后的全部菜单
				 */
				let openedMenus = this.$refs.navbar.openedMenus
				let openMenuList
				// 如果点击的是二级菜单，则获取其后已经打开的菜单
				if (indexPath.length > 1) {
					let parentPath = indexPath[indexPath.length - 2]
					openMenuList = openedMenus.slice(openedMenus.indexOf(parentPath) + 1)
				} else {
					openMenuList = openedMenus
				}

				// 关闭菜单
				openMenuList = openMenuList.reverse()
				openMenuList.forEach((ele) => {
					this.$refs.navbar.closeMenu(ele)
				})
			},
		},
		computed: {
			...mapGetters(['sidebar']),
			defActive() {
				return this.$route.path
			},
			isCollapse() {
				return !this.sidebar.opened
			}
		}
	}
</script>

<style lang="less">
	.aside {
		transition: all .3s;
		width: 210px;
		min-height: 100vh;
		color: #fff;
		box-shadow: 2px 0 6px rgb(0 21 41 / 35%);
		flex-shrink: 0;

		.side-title {
			height: 64px;
			line-height: 64px;
			font-size: 20px;
			font-weight: 600;
			vertical-align: middle;
			background: #222d32;

			img {
				vertical-align: middle;
				width: 36px;
				height: 36px;
				padding-left: 12px;
				margin-right: 10px;
			}
		}

		.side-nav {
			height: calc(100vh - 64px);

			.el-menu {
				border: none;
				height: 100%;
			}

			.el-menu-item {
				width: 100%;
				color: hsla(255, 255, 255, 0.65);

				&:hover {
					color: #fff;
				}
			}
		}
	}

	.aside-collapse {
		width: 64px;

		.side-nav {
			width: 100%;

			.el-menu--collapse {
				width: 100% !important;
			}
		}
	}

	@media screen and (max-width: 767px) {
		.aside-collapse {
			width: 0;
			overflow: hidden;
		}
	}
</style>
